export enum TipoRnt {
	Establecimiento = 1,
	Guia = 2,
	Inmuebles = 3,
  PlataformaDigitales = 4
}
